import Logo from '../logos/heatensim';

export default Logo;
